const BASE_URL = process.env.REACT_APP_BASE_URL || "";

export const getExploreUrl = `${BASE_URL}/tiktok-user/search`;
export const searchFantechUsersUrl = `${BASE_URL}/tiktok-user/search-fantech`;
export const getTiktokUserByIdUrl = (id: string) =>
  `${BASE_URL}/tiktok-user/${id}/detail`;
export const getTiktokUserHoldingByIdUrl = (id: string) =>
  `${BASE_URL}/tiktok-user/${id}/holdings`;
export const getTiktokUserHoldersByIdUrl = (id: string) =>
  `${BASE_URL}/tiktok-user/${id}/holders`;
export const getUserActivitiesByIdUrl = (id: string) =>
  `${BASE_URL}/user/${id}/activity`;
export const getUserTradeByIdUrl = (id: string) =>
  `${BASE_URL}/user/${id}/trade`;

export const getSubscribedUrl = `${BASE_URL}/user/subscribe-action`;
export const getAuthUrl = `${BASE_URL}/auth`;
export const getUserUrl = `${BASE_URL}/user`;
export const getUserProfileUrl = `${BASE_URL}/user/profile`;
export const getUserStatisticUrl = `${BASE_URL}/user/statistic`;
export const updateInviteCodeUrl = `${BASE_URL}/user/update-invite-code`;
export const delegateInitializeShares = `${BASE_URL}/auth/delegate-initialize-shares`;
export const generateTiktokCodeUrl = `${BASE_URL}/auth/generate-tiktok-code`;
export const getTwitterAuthUrl = `${BASE_URL}/auth/login/twitter-auth-url`;
export const postLoginTwitterUrl = `${BASE_URL}/auth/login/link-twitter`;
export const confirmTiktokCodeUrl = `${BASE_URL}/auth/confirm-tiktok-code`;
export const configTiktokUrl = `${BASE_URL}/admin-config/tiktok-config`;
export const getTiktokFollowingUrl = `${BASE_URL}/tiktok-following`;
export const getTiktokUserTrendingUsersUrl = `${BASE_URL}/tiktok-user/trending-users`;
export const getTiktokUserUpcomingUsersUrl = `${BASE_URL}/tiktok-user/upcoming-users`;
export const getSubscribeUrl = `${BASE_URL}/subscription/subscribe`;
export const getunsubscribeUrl = `${BASE_URL}/subscription/unsubscribe`;
export const getLiveInfoUrl = `${BASE_URL}/user/live-info`;
export const getClientVersionUrl = `${BASE_URL}/admin-config/client-version`;
